import { useEffect, useRef } from "react";

const BEEHIIV_LOADER_SRC = "https://subscribe-forms.beehiiv.com/v3/loader.js";
const BEEHIIV_FORM_ID = "a99518ac-600c-46e4-983e-b6bc3744ba71";

/**
 * Mounts the Beehiiv subscribe form embed. The loader script reads
 * `data-beehiiv-form` and injects the form into the surrounding container.
 *
 * Reused by /newsletter and /newsletter/:slug — both the hero subscribe and
 * the bottom CTA point at the same Beehiiv form ID.
 */
export default function BeehiivSubscribeForm({
  className,
}: {
  className?: string;
}) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    // Avoid double-injecting if the component remounts within the same load.
    if (
      container.querySelector(
        `script[data-beehiiv-form="${BEEHIIV_FORM_ID}"]`,
      )
    ) {
      return;
    }
    const script = document.createElement("script");
    script.async = true;
    script.src = BEEHIIV_LOADER_SRC;
    script.setAttribute("data-beehiiv-form", BEEHIIV_FORM_ID);
    container.appendChild(script);
    return () => {
      // Best-effort cleanup so navigations don't accumulate scripts.
      if (script.parentNode === container) container.removeChild(script);
    };
  }, []);

  return <div ref={containerRef} className={className} />;
}
